import { Button, Modal } from '@teamsnap/teamsnap-ui';
import * as React from 'react';
import * as Types from '../types';

import './DepositAccountWarningModal.scss';

type Props = {
  orgId: Number;
  formId: number;
  show: boolean;
  onClose?: () => any;
  setCurrentStep?: (step) => any;
  children?: React.ReactNode;
};

const DepositAccountWarningModal = ({ orgId, formId, show, setCurrentStep, onClose }: Props) => (
  <>
    {show && (
      <div data-testid="deposit-account-warning-modal" id="deposit-account-warning-modal">
        <Modal heading={''} show={true}>
          <div className="deposit-account-warning-modal__content">
            <p>
              Merchant account has not been selected. You will need to remove{' '}

              <a href={`/organizations/${orgId}/registration/${formId}/${Types.RegistrationSteps.REGISTRATION_FEES}`}
                data-testid="deposit-account-warning-modal__fees-action"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(Types.RegistrationSteps.REGISTRATION_FEES);
                  onClose();
                }}
              >fees
              </a> or select a{' '}
              <a href={`/organizations/${orgId}/registration/${formId}/${Types.RegistrationSteps.DEPOSIT_ACCOUNT}`}
                data-testid="deposit-account-warning-modal__deposit-account-action"
                onClick={(e) => {
                  e.preventDefault();
                  setCurrentStep(Types.RegistrationSteps.DEPOSIT_ACCOUNT);
                  onClose();
                }}
              >merchant account
              </a>.
            </p>
          </div>
          <div className="buttons-wrapper">
            {onClose && (
              <Button
                mods="Button Button--primary"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
              >
                Close
              </Button>
            )}
          </div>
        </Modal>
      </div>
    )}
  </>
);

export default DepositAccountWarningModal;
